<i [ngClass]="iconClass" aria-hidden="true"></i>
